import { render } from "./MobileAboutView.vue?vue&type=template&id=ea712856&scoped=true"
const script = {}

import "./MobileAboutView.vue?vue&type=style&index=0&id=ea712856&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea712856"]])

export default __exports__